<template>
  <div>
    <div style="margin-bottom: 20px;margin-top: 30px">
      <router-view></router-view>
      <el-button size="small" type="success" icon="el-icon-plus" v-if="['ADMIN','MANAGER','TECH'].includes(role)"
        @click="handleEdit()">添加</el-button>
      <el-button size="small" type="danger" icon="el-icon-delete" v-if="['ADMIN','MANAGER','TECH'].includes(role)"
        @click="handleDelete()">批量删除</el-button>
    </div>
    <table-col :cols="column" :table-col="column" :columnType="'lexiconTableCol' + activeTab" @submit="getCheckedBox"></table-col>
    <el-tabs v-model="activeTab" @tab-click="changeTab">
      <el-tab-pane v-for="(item,tabIndex) in data" :label="item.label" :name="item.name"></el-tab-pane>
    </el-tabs>
    <w-table :columns="checkedCol" :table-data="tableData" @rowSelection="rowSelection($event)"
      :key="activeTab" @getTableSearchSortCon="(...event) => { getTableSearchSortCon(event) }" :isPagination="true"
      ref="wMyTable" :page="page" @pageChange="handlePagePagination"
      :isShowRowSelection="true">
      <div slot="operation" slot-scope="{record}">
        <el-button size="mini" type="warning"
          v-if="['ADMIN','MANAGER','TECH','SALES_ASSI_MANAGER','SALES_ASSI'].includes(role)"
          @click="handleEdit(record)">编辑</el-button>
        <el-button size="mini" type="danger" icon="el-icon-delete" v-if="['ADMIN','MANAGER','TECH'].includes(role)"
          @click="handleDelete(record)">删除</el-button>
        <el-button size="mini" type="danger"
          v-if="record['materialStatus'] && ['ADMIN','MANAGER','SALES_ASSI_MANAGER','SALES_ASSI'].includes(role)"
          @click="handleUpdate(record,false)">暂停申请</el-button>
        <el-button size="mini" type="success"
          v-if="['ADMIN','MANAGER','SALES_ASSI_MANAGER','SALES_ASSI'].includes(role) && !record['materialStatus']"
          @click="handleUpdate(record,true)">恢复申请</el-button>
        <el-button size="mini" type="primary"
          v-if="['ADMIN','MANAGER','TECH','SALES_ASSI_MANAGER','SALES_ASSI','SALES','SALES_MANAGER'].includes(role) && record['annexExistFlag']"
          icon="el-icon-download" @click="download(record)">下载附件</el-button>
      </div>
      <div slot="materialType" slot-scope="{record,text}">
        <el-tag :type="getMaterialColor(text,'tagType')"
          :style="{color: getMaterialColor(text,'color'),'background-color':getMaterialColor(text,'backgroundColor')}">
          {{getMaterialColor(text,'name')}}</el-tag>
      </div>
      <div slot="materialStatus" slot-scope="{record,text}">
        <el-tag v-if="text && record.number>0" type="success">可申请</el-tag>
        <el-tag v-else-if="!text || record.number<=0" type="danger">不可申请</el-tag>
        <el-tag v-else type="info">未知状态</el-tag>
      </div>
       <div slot="limitQuantity" slot-scope="{record,text}">
        <span v-if="text">{{ text }}</span>
        <span v-else>无限制</span>
      </div>
      <div slot="filterType" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
        style="padding: 8px; position: relative; z-index: 9999 !important;">
        <div style="padding: 15px 15px 0">
          <el-radio-group v-model="selectedKeys[0]">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='PROTECT_REAGENT'>保护剂</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='NAME_CARD'>名片</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='SINGLE_PAGER'>宣传品</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='GIFT'>礼品</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='DRY_ICE'>干冰</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='OTHER'>其他</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
          </a-button>
        </div>
      </div>
    </w-table>
    <picture-loading v-if="loading"></picture-loading>
    <add-edit-lexicon v-if="showAddEditDialog" :show-dialog="showAddEditDialog" :select-type="selectType"
      :select-detail="selectDetail" @submit="closeAddEditDialog"></add-edit-lexicon>
    <lexicon-details v-if="showDetailsDialog" :show-dialog="showDetailsDialog" :select-detail="showDetails"
      @submit="close"></lexicon-details>
  </div>
</template>


<script>

import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import {tableOperationMixin} from "@/mixins/tableOperation";
import {lexicon} from "@/utils/data/tableCol/material/lexicon/lexicon";
import {attachmentAnnex, deleteLexicon, getLexiconPage, updateMaterialStatus} from "@/api/dilivery/material/lexicon";
import {getDataInLocalStorage} from "@/utils/localStorage";
import AddEditLexicon from "@/components/material/lexicon/AddEditLexicon.vue";
import LexiconDetails from "@/components/material/lexicon/LexiconDetails.vue";
import TableCol from "@/components/customerTable/TableCol.vue";
import {exportLexicon} from "@/utils/data/tableCol/material/lexicon/exportLexicon";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import _ from "lodash";
import {getMaterialColor} from "@/color";

const baseURL = process.env.VUE_APP_BASE_API


export default {
  name: "Lexicon",
  components: {PictureLoading, TableCol, LexiconDetails, AddEditLexicon, TableHeadNote},
  mixins: [tableOperationMixin],
  data() {
    return {
      tableData: [],
      selectable: [],
      searchConditionTag: [],
      sortConditionTag: [],
      page: { pageSize: 10, currentNum: 1, total: null },
      data: [
        { label: '宣传品', name: 'SINGLE_PAGER', showBadge: false },
        { label: '礼品', name: 'GIFT', showBadge: false },
        { label: '干冰', name: 'DRY_ICE', showBadge: false },
        { label: '保护剂', name: 'PROTECT_REAGENT', showBadge: false },
        { label: '名片', name: 'NAME_CARD', showBadge: false },
        { label: '其他', name: 'OTHER', showBadge: false },
      ],
      sendData: {
        SINGLE_PAGER: { "query#materialType.EQ": "SINGLE_PAGER" },
        GIFT: { "query#materialType.EQ": "GIFT" },
        DRY_ICE: { "query#materialType.EQ": "DRY_ICE" },
        PROTECT_REAGENT: { "query#materialType.EQ": "PROTECT_REAGENT" },
        NAME_CARD: { "query#materialType.EQ": "NAME_CARD" },
        OTHER: { "query#materialType.EQ": "OTHER" },
      },
      pageTotal: { SINGLE_PAGER: 0, GIFT: 0, DRY_ICE: 0, PROTECT_REAGENT: 0, NAME_CARD: 0, OTHER: 0 },
      userData: {},
      role: '',
      loading: true,
      activeTab: 'SINGLE_PAGER',
      fileData: [],
      checkedCol: [],
      showDetailsDialog: false,
      showDetails: '',
      showAddEditDialog: false,
      selectDetail: '',
      selectType: '',
    }
  },
  computed: {
    column() {
      let cols = lexicon([] || {})
      if (this.activeTab !== 'SINGLE_PAGER') {
        cols = cols.filter(item => !['classOne','classTwo'].includes(item.key))
      }
      return JSON.parse(JSON.stringify(cols))
    },
  },
  created() {
    this.userData = JSON.parse(getDataInLocalStorage('user'))
    this.role = getDataInLocalStorage('role')
  },
  mounted() {
    this.getData()
  },
  methods: {
    getMaterialColor,
    getCheckedBox(col, cols) {
      this.checkedCol = col.filter(item => cols.includes(item.title))
    },
    handleUpdate(row, status) {
      updateMaterialStatus(row.id, status).then(res => {
        if (res.code === 200) {
          this.getData()
          this.$messageUi.success('修改物料状态成功')
        }
      }).catch(err => {})
    },
    async download(row) {
      try {
        let url = `${baseURL}/material-lexicon/annex/${row.id}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
        const elink = document.createElement('a')
        elink.href = url
        document.body.appendChild(elink)
        elink.style.display = "none"
        elink.click()
        document.body.removeChild(elink);
      } catch (error) {
        console.log(error);
      }
    },
    rowSelection(selectedRows) {
      this.selectable = _.unionBy(this.selectable, selectedRows, 'id').filter(item => this.$refs.wMyTable.selectedRowKeys.includes(item.id));
    },
    changeTab() {
      this.$nextTick(() => {
        this.tableData = []
        this.selectable = []
        this.searchConditionTag = []
        this.sortConditionTag = []
        this.page = { pageSize: 10, currentNum: 1, total: null }
        if (this.$refs.wMyTable) {
          this.$refs.wMyTable.selectedRowKeys = []
          this.$refs.wMyTable.searchConditionTag = []
        }
        this.getData()
      })
    },
    getTableSearchSortCon(ConditionTag) {
      this.searchConditionTag = ConditionTag[0]
      this.sortConditionTag = ConditionTag[1]
      this.getData('search')
    },
    getData(searchFlag) {
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
        'order': 'materialNumber.descend'
      }
      if (searchFlag) {
        params = { 'page.current': 1, 'page.size': 10}
      }
      if (this.sortConditionTag && this.sortConditionTag.length > 0) {
        params["order"] = this.sortConditionTag.map(sortCondition => {
          return sortCondition.colName + "." + sortCondition.order;
        }).join(",");
      }
      let sendData = { ...this.sendData[this.activeTab] }
      if (this.searchConditionTag && this.searchConditionTag.length) {
        sendData = this.getSearch(sendData)
      }
      getLexiconPage(params, sendData).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.records
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
          this.$set(this.pageTotal, this.activeTab, parseInt(res.data.total))
        }
      }).catch(error => {
        this.loading = false
      })
    },
    getSearch(sendData) {
      
      this.searchConditionTag.forEach(item => {
        sendData["query#" + item.key + ".LIKE"] = item.value
      })
      return sendData
    },
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    handleEdit(row) {
      if (row !== undefined && row !== 'undefined') {
        this.selectDetail = row
        this.selectType = 'edit'
      } else {
        this.selectType = 'add'
        this.selectDetail = ''
      }
      this.showAddEditDialog = true
    },
    handleDelete(row) {
      let ids = []
      if (row) {
        ids = [row.id]
      } else {
        ids = this.selectable.map(item => item.id)
        if (ids.length === 0) {
          this.$messageUi.error('请选择需批量删除的物料数据')
          return
        }
      }
      this.$confirmUi('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = { "ids": ids.join(',') }
        deleteLexicon(param).then(res => {
          if (res.code === 200) {
            this.$messageUi({ type: 'success', message: '删除成功!' })
            const totalPage = Math.ceil((this.page.total - 1) / this.page.pageSize)
            this.page.currentNum = this.page.currentNum > totalPage ? totalPage : this.page.currentNum
            this.page.currentNum = this.page.currentNum < 1 ? 1 : this.page.currentNum
            this.getData()
          }
        }).catch(err => {})
      }).catch(() => {})
    },
    close() {
      this.$nextTick(() => { this.showDetailsDialog = false })
    },
    closeAddEditDialog(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$nextTick(() => { this.showAddEditDialog = false })
    }
  }
}
</script>

<style scoped>
.status-tag-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
